import {
  decimal,
  email,
  helpers,
  maxLength,
  minLength,
  numeric,
  required,
} from '@vuelidate/validators'

import InputFieldPlugin from '@/features/settingsManagement/fieldManagement/edit/plugin/inputFieldPlugin/InputFieldPlugin.vue'
import InputFieldPluginValueRenderer from '@/features/settingsManagement/fieldManagement/edit/plugin/inputFieldPlugin/InputFieldPluginValueRenderer.vue'
import { normalizeFieldExtraData } from '@/features/settingsManagement/fieldManagement/edit/utils/fieldUtils.js'

export const inputFieldPlugin = {
  type: 'input',
  component: InputFieldPlugin,
  valueRenderer: InputFieldPluginValueRenderer,
  defaultExtraData: {
    placeholder: 'Enter...',
    fieldType: 'input',
    inputMode: 'text',
  },
  getValidations({ props }) {
    const field = props.field
    const extraData = normalizeFieldExtraData(field.extraData)
    const rules = {}
    const key = field.key

    const isRequired =
      typeof props.externalRequired === 'boolean' ? props.externalRequired : field.isCompulsory

    if (isRequired) {
      const message = `${key} is required`
      rules.required = helpers.withMessage(message, required)
    }

    switch (extraData.inputMode) {
      case 'numeric':
        rules.numeric = helpers.withMessage(`${key} must be a number`, numeric)
        break
      case 'decimal':
        rules.decimal = helpers.withMessage(`${key} must be a decimal`, decimal)
        break
      case 'email':
        rules.email = helpers.withMessage(`${key} must be a valid email`, email)
        break
      case 'password':
        rules.minLength = helpers.withMessage(`${key} must be at least 6 characters`, minLength(6))
        break
    }

    if (extraData.minLength) {
      rules.minLength = helpers.withMessage(
        `${key} must be at least ${extraData.minLength} characters`,
        minLength(extraData.minLength),
      )
    }

    if (extraData.maxLength) {
      rules.maxLength = helpers.withMessage(
        `${key} must be at most ${extraData.maxLength} characters`,
        maxLength(extraData.maxLength),
      )
    }

    if (extraData.customRegex) {
      rules.customRegex = helpers.withMessage(
        extraData.customRegexMessage || '_invalidFormat',
        value => {
          if (!value) return true
          try {
            const regex = new RegExp(extraData.customRegex)
            return regex.test(value)
          } catch (e) {
            console.error('[inputFieldPlugin] Invalid regex pattern:', e)
            return false
          }
        },
      )
    }
    return rules
  },
}
